export const specialOptions = [
    {
        name: 'VEGAN_OPTIONS'
    },
    {
        name: 'VEGETARIAN_OPTIONS'
    },
    {
        name: 'GLUTEN_FREE_OPTIONS'
    },
    {
        name: 'HALAL'
    },
    {
        name: 'KOSHER'
    }
]